import { render, staticRenderFns } from "./OrbitForceEndRoundModal.vue?vue&type=template&id=1da55ee0"
import script from "./OrbitForceEndRoundModal.vue?vue&type=script&lang=ts"
export * from "./OrbitForceEndRoundModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitForceEndRoundModal.vue?vue&type=style&index=0&id=1da55ee0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports